import { Labels } from 'magpie-types';

export const labelsMapToJsonSerializableRecord = (
  labels: Map<string, ReadonlySet<string>>
): Labels => {
  return Object.fromEntries(
    Array.from(labels.entries()).map(([key, values]) => [
      key,
      Array.from(values),
    ])
  );
};
